import React, { useState, useEffect } from "react";
import {
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
} from "reactstrap";
import DeleteModal from "components/Common/DeleteModal";
import { SuccessOk } from "configs/statusCode";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const CardItem = ({
	index,
	item,
	id,
	email,
	role,
	Service,
	name,
	status,
	updateHandler,
	setShouldGetData,
}) => {
	const AuthData = useSelector((state) => state.Auth);
	const [deleteModal, setDeleteModal] = useState(false);
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const [itemStatus, setItemStatus] = useState(false);
	const service = new Service();
	const toggle = () => setDropdownOpen((prevState) => !prevState);
	const isExist = (data) =>
		AuthData.permissions.includes(data) || AuthData.email === "admin@meras.com";

	useEffect(() => {
		setItemStatus(status);
	}, [status]);

	const handleCloseModal = (action, response) => {
		setDeleteModal(false);
		if (action === "delete") {
			setShouldGetData(true);
		}
	};

	const changeStatus = (e) => {
		const value = e.target.checked;
		service.toggleStatus(id).then((res) => {
			if (res && res.status === SuccessOk) {
				setItemStatus(value);
				setTimeout(() => {
					setShouldGetData(true);
					toast.success("Status Changed successfully");
				}, 1000);
			}
		});
	};

	return (
		<>
			<tr key={index}>
				<td className="font-size-16">{id}</td>
				<td className="font-size-16">{name}</td>
				<td className="font-size-16">{email}</td>
				<td className="font-size-16">{role.name.en}</td>
				<td className="font-size-16">
					{item.invitation_sender.en ? item.invitation_sender.en : ""}
				</td>
				<td className="font-size-14 py-0">
					<form>
						<div className="form-check form-switch form-switch-md mb-1">
							<input
								name="status"
								checked={itemStatus}
								type="checkbox"
								className="form-check-input"
								id="has_status"
								onChange={changeStatus}
								disabled={isExist("admins.edit") ? false : true}
							/>
						</div>
					</form>
				</td>
				{isExist("admins.edit") || isExist("admins.delete") ? (
					<td className="removebtnhover">
						<Dropdown
							color="light"
							className="dropdownWidth"
							isOpen={dropdownOpen}
							toggle={toggle}>
							<DropdownToggle caret>
								<i className="fa fa-ellipsis-v text-dark fa-lg"></i>
							</DropdownToggle>
							<DropdownMenu>
								{isExist("admins.edit") ? (
									<DropdownItem
										onClick={() => {
											updateHandler();
										}}>
										Edit
									</DropdownItem>
								) : null}
								{isExist("admins.delete") ? (
									<DropdownItem
										onClick={() => {
											setDeleteModal(!deleteModal);
										}}>
										<span className=".text-danger" style={{ color: "red" }}>
											Remove Admin
										</span>
									</DropdownItem>
								) : null}
							</DropdownMenu>
						</Dropdown>
					</td>
				) : null}
			</tr>
			<DeleteModal
				open={deleteModal}
				titleMsg={name.en}
				deletedItem={item}
				modelService={service}
				onCloseModal={(action) => handleCloseModal(action)}
			/>
		</>
	);
};

export default CardItem;
